import React from "react";
import pressedFlower from "../../images/pressedflower.jpeg"
import "./home.css"

const Home = () => {
    return (
        <div className="center-wrapper">
            <p className = "intro">
            Welcome! My belief is that a novel can affect us like a flower being pressed in a book. It shapes us, helps us hold onto what is good and beautiful. May these books be that for you.  And like that flower, by being my readers, you have left an imprint on my story as well.
            </p>
            <img className="pressed-flower" src={pressedFlower}/>
        </div>
    )
}

export default Home;